module.exports = __webpack_public_path__ + "images/adaptiveAutomationPoster.975d2a1c163ea026b7f9cb62ebf29bc1.png";